import React, { type ChangeEvent, type FocusEventHandler, type KeyboardEvent } from "react";
import style from "./inputCount.module.css";

type InputCountProps = {
    value: string;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
    onBlur?: FocusEventHandler<HTMLInputElement>;
};

export const InputCount = ({ value, onChange, onKeyDown, onBlur }: InputCountProps) => {
    return (
        <input
            type="number"
            min={1}
            max={99}
            value={value}
            onChange={onChange}
            onKeyDown={onKeyDown}
            onBlur={onBlur}
            className={style.inputCount}
        />
    );
};
